export const slots = [
    {
        slotName: "10:00",
        isBooked: false,
        displayTime: "10:00 am"
    },
    {
        slotName: "10:30",
        isBooked: true,
        displayTime: "10:30 am"
    },
    {
        slotName: "11:00",
        isBooked: true,
        displayTime: "11:00 am"
    },
    {
        slotName: "12:00",
        isBooked: true,
        displayTime: "12:00 pm"
    },
    {
        slotName: "12:30",
        isBooked: true,
        displayTime: "12:30 pm"
    },
    {
        slotName: "13:00",
        isBooked: false,
        displayTime: "01:00 pm"
    },
    {
        slotName: "13:30",
        isBooked: false,
        displayTime: "01:30 pm"
    },
    {
        slotName: "14:00",
        isBooked: true,
        displayTime: "02:00 pm"
    },
    {
        slotName: "14:30",
        isBooked: true,
        displayTime: "02:30 pm"
    },
    {
        slotName: "15:00",
        isBooked: true,
        displayTime: "03:00 pm"
    },
    {
        slotName: "15:30",
        isBooked: true,
        displayTime: "03:30 pm"
    },
    {
        slotName: "16:00",
        isBooked: true,
        displayTime: "04:00 pm"
    },
    {
        slotName: "16:30",
        isBooked: true,
        displayTime: "04:30 pm"
    },
    {
        slotName: "17:00",
        isBooked: false,
        displayTime: "05:00 pm"
    },
    {
        slotName: "17:30",
        isBooked: true,
        displayTime: "05:30 pm"
    },
    {
        slotName: "18:00",
        isBooked: true,
        displayTime: "06:00 pm"
    },
    {
        slotName: "18:30",
        isBooked: true,
        displayTime: "06:30 pm"
    },
    {
        slotName: "19:00",
        isBooked: true,
        displayTime: "07:00 pm"
    },
]